'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useContext } from 'react';

import { PreviousPathnameContext } from 'contexts/PreviousPathnameContext';
import { useRouter } from 'next-nprogress-bar';

import ButtonCTA from 'components/ui/ButtonCTA';
import Img from 'components/ui/Img';
import Text from 'components/ui/Text';

import styles from './NotFound.module.scss';

const ErrorPage = () => {
    const router = useRouter();
    const previousPathname = useContext(PreviousPathnameContext);

    return (
        <div className={styles.container}>
            <Text
                className={styles.headline}
                as="h1"
                baseTheme="displaySmall"
                themes={{ medium: 'displayLarge' }}
            >
                Well, this isn’t grate
            </Text>
            <Text
                className={styles.copy}
                as="p"
                baseTheme="bodyMedium"
                themes={{ medium: 'bodyLarge' }}
            >
                We can’t seem to find the page you’re looking for. Sorry about
                that!
            </Text>
            {previousPathname ? (
                <ButtonCTA
                    text="Back"
                    style="filled-blue-ocean"
                    onClick={() => router.back()}
                />
            ) : (
                <ButtonCTA
                    text="Home"
                    style="filled-blue-ocean"
                    link={{ slug: '/' }}
                />
            )}
            <figure className={styles.imageWrapper}>
                <Img
                    src="https://images.ctfassets.net/j8tkpy1gjhi5/3jkzmNp6SF4bsl2liTNiRA/7ae0f7a8be5008608cdfe1764594cf81/DIGITAL-shreds-side---KO_1.png"
                    width={1274}
                    height={1344}
                    fallbackImageWidth={1274}
                    alt="Cheese Shreds"
                />
            </figure>
        </div>
    );
};

export default ErrorPage;
